<template>
    <vx-expandable-card>
        <template v-slot:header>Documentation</template>
        <template v-slot:content>
            <div class="mb-4">
                With the Voxie App for HubSpot, you can add contacts to Voxie directly from your HubSpot Workflows. Each
                workflow action creates or updates an External List in Voxie, ready for your SMS campaigns.
            </div>
            <div class="mb-4">You control which HubSpot data flows into Voxie:</div>
            <ul class="list-disc list-inside mb-4">
                <li>Choose the phone number field to use as the contact identifier</li>
                <li>Map up to 10 HubSpot properties to Voxie custom attributes</li>
                <li>Assign contacts to specific groups for franchise targeting</li>
                <li>Add tags to organize contacts for your campaigns</li>
            </ul>
            <div class="mb-4">
                Contact details like email, name, and time zone are automatically synced from HubSpot.
            </div>
            <div>
                For step-by-step setup instructions, see the
                <a
                    href="https://fabulous-savory-985.notion.site/Set-up-HubSpot-Voxie-Integration-21787981232d80d39ff1c1404da262e6"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-sky-600 hover:underline"
                    >full documentation</a
                >.
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup lang="ts">
import { VxExpandableCard } from '@voxie/frontend-components';
</script>
